import React from 'react';
import { CircleCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { guaranteeItems } from '../../data/content';
export function Guarantee() {
  return <section className="bg-white px-4 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-125" data-mp="24mycmjmgppmu">
      <div className="mx-auto max-w-3xl" data-id="element-126" data-mp="29egi9kzfkee5">
        <div className="rounded-3xl border-2 border-dashed border-ink/25 bg-cream p-6 text-center sm:p-10" data-id="element-127" data-mp="29f807t03udly">
          <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full bg-ink ring-4 ring-gold" data-id="element-128" data-mp="2ef44zugmm92k">
            <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-129" data-mp="2ob7g3ptghi1n" />
            <span className="mt-0.5 text-xs font-black uppercase text-white" data-id="element-130" data-mp="2o9374tgp9sui">7 days</span>
          </div>
          <h2 id="guarantee-title" className="mt-5 font-serif text-[30px] font-black leading-tight text-ink sm:text-4xl" data-id="element-131" data-mp="2sag9gtkl3dwo">
            7-day money-back guarantee
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/80" data-id="element-132" data-mp="xz1kiezedihz">
            I want you to be able to go through Picking Control 30™ and determine whether it fits your operation. For the
            next 7 days, you can:
          </p>
          <ul className="mx-auto mt-6 grid max-w-xl gap-2 text-left sm:grid-cols-2" data-id="element-133" data-mp="3ivdj5nescb3r">
            {guaranteeItems.map(g => <li key={g} className="flex items-start gap-2 text-[15px] font-medium text-ink" data-id="element-134" data-mp="3dxlhi1oc9amd">
                <CircleCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-135" data-mp="fdvchjar1a4x" />
                {g}
              </li>)}
          </ul>
          <p className="mt-6 text-[16px] leading-relaxed text-ink/80" data-id="element-136" data-mp="5ggw1jotslcm">
            If you decide the system isn’t a good fit for your operation, request your refund within the guarantee period.{' '}
            <strong className="text-ink" data-id="element-137" data-mp="2q6pt7ej3cxjv">No complicated process.</strong>
          </p>
        </div>
        <SectionCta label="Try Picking Control 30™ risk-free" data-id="element-138" data-mp="2l84r19ka43ss" />
      </div>
    </section>;
}